import { render, staticRenderFns } from "./alignment-button.vue?vue&type=template&id=5a88bb86&scoped=true&"
import script from "./alignment-button.vue?vue&type=script&lang=js&"
export * from "./alignment-button.vue?vue&type=script&lang=js&"
import style0 from "./alignment-button.vue?vue&type=style&index=0&lang=less&"
import style1 from "./alignment-button.vue?vue&type=style&index=1&id=5a88bb86&scoped=true&lang=less&"
import style2 from "./alignment-button.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a88bb86",
  null
  
)

export default component.exports